import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Paper,
  Box,
  Typography,
  Chip,
  IconButton,
  Button,
  Collapse,
  Snackbar,
} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";

const TIPO_LABEL = { new: "Nuevo", improvement: "Mejora", fix: "Corrección" };
const TIPO_COLOR = { new: "primary", improvement: "default", fix: "default" };

export default function ChangelogEntryCard({ entry }) {
  const [expandido, setExpandido] = useState(false);
  const [copiado, setCopiado] = useState(false);

  const tieneMas = Boolean(entry.details) || (entry.howTo && entry.howTo.length > 0);

  function copiarLink() {
    const url = `${window.location.origin}${window.location.pathname}#${entry.id}`;
    navigator.clipboard
      .writeText(url)
      .then(() => setCopiado(true))
      .catch(() => {});
  }

  return (
    <Paper id={entry.id} style={{ padding: 16, marginBottom: 16, scrollMarginTop: 80 }}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Chip
            size="small"
            label={TIPO_LABEL[entry.type] || entry.type}
            color={TIPO_COLOR[entry.type]}
            style={{ marginBottom: 8 }}
          />
          <Typography variant="h6">{entry.title}</Typography>
        </Box>
        <IconButton size="small" onClick={copiarLink} aria-label="Copiar enlace a esta novedad">
          <LinkIcon fontSize="small" />
        </IconButton>
      </Box>

      <Typography variant="body1" style={{ marginTop: 8 }}>
        {entry.summary}
      </Typography>

      {tieneMas && (
        <Box mt={1}>
          <Button size="small" onClick={() => setExpandido((v) => !v)}>
            {expandido ? "Ver menos" : "Ver más"}
          </Button>
          <Collapse in={expandido}>
            <Box mt={1}>
              {entry.details && (
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  {entry.details}
                </Typography>
              )}
              {entry.howTo && entry.howTo.length > 0 && (
                <>
                  <Typography variant="subtitle2" gutterBottom>
                    Cómo usarlo
                  </Typography>
                  <ol style={{ paddingLeft: 20, margin: 0 }}>
                    {entry.howTo.map((paso, i) => (
                      <li key={i}>
                        <Typography variant="body2">{paso}</Typography>
                      </li>
                    ))}
                  </ol>
                </>
              )}
            </Box>
          </Collapse>
        </Box>
      )}

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={copiado}
        autoHideDuration={2500}
        onClose={() => setCopiado(false)}
        message="Enlace copiado al portapapeles"
      />
    </Paper>
  );
}

ChangelogEntryCard.propTypes = {
  entry: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    details: PropTypes.string,
    howTo: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};
